declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
    __ENV__?: Record<string, string>;
  }
}

export const initGA = (measurementId: string) => {
  if (!measurementId) return;

  // Prevent duplicate injections
  if (document.getElementById('google-analytics-script')) return;

  // Inject Global Site Tag (gtag.js)
  const script = document.createElement('script');
  script.id = 'google-analytics-script';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  // Inject configuration script
  const initScript = document.createElement('script');
  initScript.id = 'google-analytics-init';
  initScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    window.gtag = function(){window.dataLayer.push(arguments);}
    window.gtag('js', new Date());
    window.gtag('config', '${measurementId}');
  `;
  document.head.appendChild(initScript);
};

export const trackGAEvent = (eventName: string, params?: Record<string, any>) => {
  const consent = localStorage.getItem('cookie-consent');
  if (consent !== 'accepted') return;

  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  } else {
    console.warn('GA4 not initialized but event track was called:', eventName, params);
  }
};

export const setGAUserId = (userId: string) => {
  const consent = localStorage.getItem('cookie-consent');
  if (consent !== 'accepted') return;

  const gaId = window.__ENV__?.VITE_GA_TRACKING_ID;
  if (!gaId) return;

  if (typeof window.gtag === 'function') {
    window.gtag('config', gaId, {
      'user_id': userId,
    });
  }
};
